import React from 'react';
import { faHome, faPlusSquare, faSignInAlt, faRegistered, faCog, faUser } from '@fortawesome/free-solid-svg-icons';
import { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { getProfile } from '../../api/user.api';
import { setAvatarForShow, getProfileError, getProfileStart, getProfileSuccess } from '../../redux/user.slice';
import { getListRecipeForCurrentUserSuccess } from '../../redux/recipes.slide';
import { createPointForUserApi } from '../../api/point.api';
import { createNotificationApi, getListNotifiesApi } from '../../api/notification.api';
import { addListNotifies } from '../../redux/notification.slice';
import { updateTime } from '../../redux/realtime.slice';
import Navbar from '../../components/Navbar';

const NavbarContainer = () => {

    const currentUser = useSelector(state => state.auth.signIn.currentUser);
    const time = useSelector(state => state.time.value);
    const dispatch = useDispatch();

    const [showSidebar, setShowSidebar] = useState(false);
    const [height, setHeight] = useState(0);
    const [height2, setHeight2] = useState(0);

    //---------------------------Close Dropdown Profile---------------------------
    function closeDropdown() {
        setHeight(0);
    }
    //----------------------------Close Notification------------------------------
    function closeNotification() {
        setHeight2(0);
    }
    //------------------------------Close Sidebar Menu----------------------------
    function closeSidebar() {
        setShowSidebar(false);
    }
    //-------------------------------Get Profile For Logged in User---------------
    useEffect(() => {
        dispatch(getProfileStart());
        currentUser && getProfile(currentUser.token)
            .then((response) => {
                dispatch(getProfileSuccess(response.data));
                dispatch(setAvatarForShow(response.data.avatarUrl))
                dispatch(getListRecipeForCurrentUserSuccess([...response.data.recipes]))
                return response.data
            })
            .then(user => {
                if (!user.point) {
                    console.log('running create point...')
                    createPointForUserApi(currentUser.id, currentUser.token)
                        .then((res2) => {
                            createNotificationApi({
                                receiverId: currentUser.id,
                                content: "You have successfully activated your account and received 10 points. Use points to exchange your favorite recipe!",
                                type: "system_notification"
                            })
                                .then(res => {
                                    console.log(res);
                                    dispatch(updateTime());
                                })
                                .catch(err => {
                                    console.log(err)
                                })
                        })
                        .catch(err => {
                            console.log(err);
                        })
                }
            })
            .catch((err) => {
                dispatch(getProfileError("Error getting profile"));
                console.log(err)
            })

        currentUser && getListNotifiesApi(currentUser.id)
            .then(res => {
                dispatch(addListNotifies(res.data));
            })
    }, [currentUser, time, dispatch]);
    //----------------------------------List links for routers--------------------
    const links = [
        {
            name: "Home",
            path: "/",
            icon: faHome
        },
        {
            name: "Create Recipe",
            path: "/create-recipe",
            icon: faPlusSquare
        },
        {
            name: "Sign in",
            path: "/auth/sign-in",
            icon: faSignInAlt
        },
        {
            name: "Sign up",
            path: "/auth/sign-up",
            icon: faRegistered
        },
        {
            name: "Profile",
            path: "/profile/information",
            icon: faUser
        },
        {
            name: "Setting",
            path: "/settings",
            icon: faCog
        }
    ]

    return (
        <Navbar
            closeDropdown={closeDropdown}
            closeNotification={closeNotification}
            closeSidebar={closeSidebar}
            height={height}
            height2={height2}
            links={links}
            setHeight={setHeight}
            setHeight2={setHeight2}
            setShowSidebar={setShowSidebar}
            showSidebar={showSidebar}
        />
    )
}

export default NavbarContainer